import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <rect width="2" height="5" x="7" y="7" className="icon-color" rx="1" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M8 3.9c.608 0 1.1.492 1.1 1.1 0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1 0-.608.492-1.1 1.1-1.1z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M8 15c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm0-2c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <rect
          width="2"
          height="8"
          x="11"
          y="10"
          className="icon-color"
          rx="1"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M12 5.75c.69 0 1.25.56 1.25 1.25S12.69 8.25 12 8.25 10.75 7.69 10.75 7s.56-1.25 1.25-1.25z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
        />
      </g>
    </svg>
  ),
};
